import ActionColumnRenderer from '../../../app/Table/renderer/ActionColumnRenderer'
import LodgingExpenses from '../../../../models/LodgingExpenses'
import moment from 'moment'
import React from 'react'


export default class LodgingExpensesColumnRenderer extends ActionColumnRenderer<LodgingExpenses> {
    getColumns() {
        return [
            {
                name: 'Applied Date',
                selector: 'request_date',
                format: (row: {}) => {
                    if (row instanceof LodgingExpenses) {
                        const startDate = row.getRequestDate()
                        if (startDate !== null) return moment(startDate).format('LL')
                    }
                },
            },
            {
                name: 'Investigator Name',
                selector: 'investigatorId.name',
            },
            {
                name: 'Location Address',
                selector: 'requestAddress',
            },
            {
                name: 'Location Co-ordinates',
                selector: 'requestCoordinates',
                format: (row: {}) => {
                    if (row instanceof LodgingExpenses) {
                        const coordinates = row.getRequestCoordinates()
                       return `${coordinates[0]}, ${coordinates[1]}`
                    }
                },
            },
            {
                name: "Outstation Request Status",
                selector: "requestStatus",
                format: (row: {}) => {
                    if (row instanceof LodgingExpenses) {
                        const status = row.getRequestStatus();

                        return React.createElement(
                            'span',
                            {
                                style: {
                                    backgroundColor:
                                        status === 'Rejected' ? '#f44336' : '#4caf50',
                                    color: '#fff',
                                    padding: '4px 8px',
                                    borderRadius: '4px',
                                    fontWeight: 600,
                                },
                            },
                            status
                        );
                    }
                }
            },
            {
                name: "Rejection Reason",
                selector: "requestRejectionReason",
                format: (row: {}) => {
                    if (row instanceof LodgingExpenses) {
                        const reason = row.getRequestRejectionReason() || "N/A";
                       return reason;
                    }
                },                
            },
            {
                name: "Request Handled by",
                selector: "requestActionTakenBy.name",               
            },
            {
                name: 'Amount(RS)',
                selector: 'lodgingAmount',
                format: (row: {}) => {
                    if (row instanceof LodgingExpenses) {
                        const amount = row.getLodgingAmount() || "N/A"
                        return amount 
                    }
                },
            },
            {
                name: 'Actions',
                selector: '_id',
                grow: 0,
                width: '120px',
                cell: this.renderActionColumn,
            },
        ]
    }
}
